import { Alert, AlertTitle, Typography } from "@mui/material";
import { Dialog } from "components/Dialog";
import pluralize from "pluralize";

type HowToMergeDialogProps = {
  open: boolean;
  kind: string;
  onClose: () => void;
};

export function HowToMergeDialog(props: HowToMergeDialogProps) {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      title="How to merge"
      noPrimaryAction
      contentSx={{ pb: 2 }}
    >
      <Typography>
        This tool allows you to clarify one {props.kind} by choosing which fields to maintain from
        each of the selected records.
      </Typography>
      <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 2 }}>
        Please note:
      </Typography>
      <ul style={{ marginTop: 4 }}>
        <li>
          <Typography>For most rows, only 1 cell can be selected</Typography>
        </li>
        <li>
          <Typography>Multi-select rows are labeled with an asterisk (*)</Typography>
        </li>
        <li>
          <Typography>
            Using <i>Select All</i> will select every cell in the entire column and deselect the
            other columns, including any multi-selects
          </Typography>
        </li>
      </ul>
      <Alert severity="warning" sx={{ mt: 2, mb: 2 }}>
        <AlertTitle>Merging is a destructive action</AlertTitle>
        All of the original {pluralize(props.kind)} will be deleted and replaced with the singular
        merged {props.kind}.
      </Alert>
    </Dialog>
  );
}
